import React, { Component } from 'react';
import { Spin, Icon } from 'antd';
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

/**
 * @component
 * @category Form Page
 * @name TransparentOverlay
 * @description Transparent overlay on Form page while creating booking
 * <br> <br>
 * **Example**
 * ```js
 *   <TransparentOverlay />
 * ```
 */
class TransparentOverlay extends Component {
  state = {};

  render() {
    const { message } = this.props;
    return (
        <div className="spinner-overlay">
        <div style={{padding:"10px",  backgroundColor:"white"}}>
            <span
                style={{
                display: 'flex',
                flexDirection: 'column',
                }}
            >
                <Spin indicator={antIcon} className="testR1" />
                <span style={{ marginTop: '8px' }}>{message}</span>
            </span>
        </div>
        </div>
    );
  }
}
export default TransparentOverlay;
